// extracted by css-extract-rspack-plugin
export default {"sticky-controls":"CampaignsMobileList-module__sticky-controls--otXhV","stickyControls":"CampaignsMobileList-module__sticky-controls--otXhV"};